import { Component, OnInit, ViewChild } from '@angular/core';
import { AcLayerComponent, AcNotification, ActionType } from 'angular-cesium';
import { from, Observable } from 'rxjs';
import { DownloadComponent } from 'src/app/shared/components/download/download.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { GlobeService } from 'src/app/shared/services/globe.service';

@Component({
    selector: 'app-polygon-info-provider',
    templateUrl: './polygon-info-provider.component.html',
    styleUrls: ['./polygon-info-provider.component.scss'],
})
export class PolygonInfoProviderComponent implements OnInit {
    @ViewChild(AcLayerComponent) layer: AcLayerComponent;
    htmls$: Observable<AcNotification>;

    filterOptions = {
        spatial: true,
        filterValues: {},
        GeoTypeId: 1,
        GeoSpatialString: '',
    };

    htmlObj = {
        id: '0',
        actionType: ActionType.ADD_UPDATE,
        entity: {
            id: '0',
            show: false,
            name: 'Placeholder',
            position: Cesium.Cartesian3.fromDegrees(30, 30),
            data: {
                sampleCount: 0,
                measureCount: 0,
                geometryInfo: {
                    positions: [],
                    polygonStr: '',
                },
                showDialog: false,
            },
            activeComponent: null,
        },
    };

    showPopup = false;

    constructor(
        private globeService: GlobeService,
        private dialogService: DialogService,
        private downloadService: DownloadService
    ) {
        this.htmls$ = from([this.htmlObj]);
    }

    ngOnInit() {
        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.htmlObj.entity.activeComponent = DownloadComponent;
        });

        this.globeService.getPolygonSelectionInfo().subscribe((message) => {
            if (this.htmlObj) {
                this.htmlObj.entity.id = message.id;
                this.htmlObj.entity.show = message.show;
                this.htmlObj.entity.position = message.position;

                if (message.data) {
                    this.htmlObj.entity.data = message.data;

                    this.filterOptions.filterValues =
                        message.data.filterOptions.filterValues;
                    this.filterOptions.GeoTypeId =
                        message.data.filterOptions.GeoTypeId;
                    this.filterOptions.GeoSpatialString =
                        message.data.filterOptions.GeoSpatialString;
                }

                this.layer.update(this.htmlObj.entity, this.htmlObj.id);
            }
        });
    }

    closePopup() {
        if (this.htmlObj) {
            this.htmlObj.entity.id = '0';
            this.htmlObj.entity.show = false;
            this.htmlObj.entity.position = Cesium.Cartesian3.fromDegrees(
                30,
                30
            );
            this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        }
    }

    openDialog() {
        this.downloadService.setFilterValue(this.filterOptions);
        this.htmlObj.entity.data.showDialog = true;
        this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        //this.dialogService.displayComponent(DownloadComponent);
    }

    closeDialog() {
        this.htmlObj.entity.data.showDialog = false;
        if (this.layer) {
            this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        }
    }
}
